/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React, { createContext, useContext } from 'react';

const DepartmentPageTrackingContext = createContext(null);

export const useDepartmentPageTracking = () => useContext(DepartmentPageTrackingContext) || (() => {});

export const useIsDepartmentPageTrackingActive = () => Boolean(useContext(DepartmentPageTrackingContext));

export default DepartmentPageTrackingContext;
